import React from 'react'
import PageLayout from '../pagelayout';
import StoreMap from '../Booking/storemap';
import ChangePwd from './changepwd';

const StoreProfile = () => (
    <PageLayout bgWhite Map={StoreMap}>
        <ChangePwd />
    </PageLayout>
)

export default StoreProfile
